export default (siteName) => [
    {
        path: 'current-expenditure',
        name: 'current-expenditure',
        component: () => import('../../components/dashboard/Finance/CurrentExpend/index'),
        meta: {
            title: `經常性費用設定${siteName}`,
            activeMenu: 'settings',
        },
    },
    {
        path: 'current-expenditure/add',
        name: 'current-expenditure-add',
        component: () => import('../../components/dashboard/Finance/CurrentExpend/EditPage'),
        meta: {
            title: `新增經常性費用${siteName}`,
            activeMenu: 'settings',
        },
    },
    {
        path: 'current-expenditure/:sno/edit',
        name: 'current-expenditure-edit',
        component: () => import('../../components/dashboard/Finance/CurrentExpend/EditPage'),
        meta: {
            title: `編輯經常性費用${siteName}`,
            activeMenu: 'settings',
        },
    },
    {
        path: 'current-expenditure/:sno',
        name: 'current-expenditure-detail',
        component: () => import('../../components/dashboard/Finance/CurrentExpend/DetailPage'),
        meta: {
            title: `經常性費用細節${siteName}`,
            activeMenu: 'settings',
        },
    },
];
